module.exports = __webpack_public_path__ + "img/undraw_add_information_j2wg.bdca1a9f.png";